import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import ru from "./locales/ru.json";
import tk from "./locales/tk.json";

const savedLanguage = localStorage.getItem("appLanguage") || "en";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            ru: { translation: ru },
            tk: { translation: tk }
        },
        lng: savedLanguage,
        fallbackLng: "en",
        supportedLngs: ["en", "ru", "tk"],
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;